import {NgModule} from '@angular/core';
import {AjudaComponent} from './ajuda.component';


import {MatDividerModule} from '@angular/material/divider';
import {MatCardModule} from '@angular/material/card';
import {TourModule} from './tour/tour.module';
import {CdkConfigService} from "../@cdk/services/config.service";
import {MatExpansionModule} from "@angular/material/expansion";
import {MatInputModule} from "@angular/material/input";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {MatTooltipModule} from "@angular/material/tooltip";


@NgModule({
    imports: [
        MatInputModule,
        MatFormFieldModule,
        MatButtonModule,
        MatIconModule,
        MatTooltipModule,
        MatExpansionModule,
        MatDividerModule,
        MatCardModule,
        TourModule,
        AjudaComponent,
    ],
    exports: [
        AjudaComponent
    ],
    providers: [
        CdkConfigService
    ]
})
export class AjudaModule {
}
